import { FinancialConnectionStatus } from '@40seas/entities/financial-connections';
import { EnumColor } from '@40seas/frontend/common/providers';

export const financialConnectionStatusColorMapping = {
    [FinancialConnectionStatus.ACTIVE]: 'success',
    [FinancialConnectionStatus.INACTIVE]: 'error',
    [FinancialConnectionStatus.DISCONNECTED]: 'error',
    [FinancialConnectionStatus.SUSPENDED]: 'warning',
} as { [key in FinancialConnectionStatus]: EnumColor };
